// Canonical (i) info-button copy for the listing editor. Exact text from the
// shared listing-editor UX spec. Keyed by field so <FieldInfo /> callers and
// the preview stay in sync.
export const FIELD_INFO = {
  "type.template":
    "Billing style — recurring subscription, one-time purchase, or prepaid credits.",
  "type.required_fields":
    "Info collected from the customer at checkout for this product type (e.g. domain name); set field type and whether it's mandatory.",
  interval:
    "Billing cadence — e.g. every 1 month, every 1 year, or lifetime (no expiry).",
  "plan.name": "Plan name shown to customers on the marketplace card.",
  "plan.description": "Short description shown under the plan name.",
  "plan.currency":
    "Billing currency (INR/USD) — sets the Stripe account and tax applied.",
  "plan.region": "Which storefront shows this plan — Global, India, or US.",
  "plan.price_type":
    "‘Price’ = purchasable with tiers. ‘Contact us’ = hides price and shows a contact form; the enquiry is emailed to the product owner.",
  "plan.unit_price_type":
    "Full = every unit billed at the tier the total quantity falls in. Partial (tiered/prorata) = quantity split cumulatively across tiers.",
  "plan.modify_orders":
    "How a mid-cycle quantity change is billed — prorated now, at next renewal, or current period.",
  "plan.trial_period_days": "Free-trial length before the first charge.",
  "plan.price_validity":
    "How long this price stays locked before it can roll to a new price.",
  "plan.tags": "Labels shown on the plan card (e.g. Popular).",
  "plan.plan_highlight": "Bullet points listed on the plan card.",
  "plan.status":
    "Active = purchasable. Out Of Stock = shown but not buyable. Inactive = hidden.",
  "unit.start_range": "Quantity band this tier applies to (e.g. 1–10 seats).",
  "unit.end_range": "Quantity band this tier applies to (e.g. 1–10 seats).",
  "unit.steps": "Quantity increment allowed within this band.",
  "unit.marketplace_price":
    "What the customer pays per unit — shown on the marketplace.",
  "unit.industry_price":
    "List/market price per unit — used to show the customer their savings (industry − marketplace). Not charged.",
  "unit.vendor_price":
    "What the vendor is paid per unit (payout basis). Internal — never shown to the customer.",
  "unit.min_price":
    "Lowest/highest the per-unit price may be set to — guardrails for overrides and negotiated deals.",
  "unit.max_price":
    "Lowest/highest the per-unit price may be set to — guardrails for overrides and negotiated deals.",
  "unit.hsn_code": "Tax HSN/SAC code used on the invoice.",
  "unit.default":
    "Marks the tier shown by default on the marketplace card (which price the customer sees first).",
};
